import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { FEATURES } from 'collaboration-sidebar/constants/features';
import { convertEnabledFeatures } from '../utils';
import useFrameworkAppSettings from './useFrameworkAppSettings';
export default function useGetPropsFromFAS(t0) {
  "use memo";

  const $ = _c(13);
  const {
    appName,
    enabledFeatures,
    skipFas: t1
  } = t0;
  const skipFas = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== skipFas) {
    t2 = {
      skip: skipFas
    };
    $[0] = skipFas;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    getCollaborationSidebarAppSetting,
    getCommentingAppSetting,
    loading
  } = useFrameworkAppSettings(t2);
  let t3;
  if ($[2] !== appName || $[3] !== enabledFeatures || $[4] !== getCollaborationSidebarAppSetting || $[5] !== getCommentingAppSetting || $[6] !== loading) {
    bb0: {
      var _collaborationSidebar, _getCommentingAppSett, _collaborationSidebar2, _collaborationSidebar3, _collaborationSidebar4, _collaborationSidebar5, _collaborationSidebar6, _collaborationSidebar7, _collaborationSidebar8, _collaborationSidebar9;
      const collaborationSidebarAppSettings = getCollaborationSidebarAppSetting(appName);
      if (!collaborationSidebarAppSettings) {
        let t4;
        if ($[8] !== loading) {
          t4 = {
            loading,
            fasProps: undefined
          };
          $[8] = loading;
          $[9] = t4;
        } else {
          t4 = $[9];
        }
        t3 = t4;
        break bb0;
      }
      const objectTypeFromFAS = (_collaborationSidebar = collaborationSidebarAppSettings.objectType) === null || _collaborationSidebar === void 0 ? void 0 : _collaborationSidebar.value;
      const isCommentingAppSettingsEnabled = Boolean(objectTypeFromFAS && ((_getCommentingAppSett = getCommentingAppSetting(objectTypeFromFAS)) === null || _getCommentingAppSett === void 0 ? void 0 : _getCommentingAppSett.enabled.value));
      let fasEnabledFeatures = collaborationSidebarAppSettings.enabledFeatures;
      if (!isCommentingAppSettingsEnabled && fasEnabledFeatures) {
        fasEnabledFeatures = Object.assign({}, fasEnabledFeatures, {
          value: fasEnabledFeatures.value.filter(_temp)
        });
      }
      const appHub = collaborationSidebarAppSettings.appHubs;
      const props = {
        appHub: appHub === null || appHub === void 0 ? void 0 : appHub.value,
        defaultSidebarPlacement: (_collaborationSidebar2 = collaborationSidebarAppSettings.dragAndDropConfig) === null || _collaborationSidebar2 === void 0 || (_collaborationSidebar2 = _collaborationSidebar2.value) === null || _collaborationSidebar2 === void 0 ? void 0 : _collaborationSidebar2.defaultSidebarPlacement,
        dragAndDropAreas: (_collaborationSidebar3 = collaborationSidebarAppSettings.dragAndDropConfig) === null || _collaborationSidebar3 === void 0 || (_collaborationSidebar3 = _collaborationSidebar3.value) === null || _collaborationSidebar3 === void 0 ? void 0 : _collaborationSidebar3.dragAndDropAreas,
        enabledFeatures: convertEnabledFeatures({
          appHub,
          fasEnabledFeatures,
          propEnabledFeatures: enabledFeatures
        }),
        hideCommentModeAndToggle: (_collaborationSidebar4 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar4 === void 0 || (_collaborationSidebar4 = _collaborationSidebar4.value) === null || _collaborationSidebar4 === void 0 ? void 0 : _collaborationSidebar4.hideCommentModeAndToggle,
        isListingPage: (_collaborationSidebar5 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar5 === void 0 || (_collaborationSidebar5 = _collaborationSidebar5.value) === null || _collaborationSidebar5 === void 0 ? void 0 : _collaborationSidebar5.isListingPage,
        isOverlay: (_collaborationSidebar6 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar6 === void 0 || (_collaborationSidebar6 = _collaborationSidebar6.value) === null || _collaborationSidebar6 === void 0 ? void 0 : _collaborationSidebar6.isOverlay,
        objectType: objectTypeFromFAS,
        scrollablePage: (_collaborationSidebar7 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar7 === void 0 || (_collaborationSidebar7 = _collaborationSidebar7.value) === null || _collaborationSidebar7 === void 0 ? void 0 : _collaborationSidebar7.scrollablePage,
        showSidebarHeader: (_collaborationSidebar8 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar8 === void 0 || (_collaborationSidebar8 = _collaborationSidebar8.value) === null || _collaborationSidebar8 === void 0 ? void 0 : _collaborationSidebar8.showSidebarHeader,
        withoutSidebar: (_collaborationSidebar9 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar9 === void 0 || (_collaborationSidebar9 = _collaborationSidebar9.value) === null || _collaborationSidebar9 === void 0 ? void 0 : _collaborationSidebar9.withoutSidebar
      };
      let t4;
      if ($[10] !== loading || $[11] !== props) {
        t4 = {
          loading,
          fasProps: props
        };
        $[10] = loading;
        $[11] = props;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      t3 = t4;
    }
    $[2] = appName;
    $[3] = enabledFeatures;
    $[4] = getCollaborationSidebarAppSetting;
    $[5] = getCommentingAppSetting;
    $[6] = loading;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(feature) {
  return feature.name !== FEATURES.COMMENTS && feature.name !== FEATURES.DEEP_COMMENTING;
}